import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthService, RoutingService} from '@spartacus/core';

const CDC_USER = '---CDC---';

@Component({
    selector: 'aimo-cx-login-form',
    templateUrl: './aimo-process-cdc-login.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoProcessCdcLoginComponent implements OnInit {
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected authService: AuthService,
        protected routingService: RoutingService,
    ) {
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe(params => {
            this.authService.loginWithCredentials(CDC_USER, params.code)
                .catch(
                    () => this.routingService.go('/')
                );
        })
    }
}
